'use client';

import { ComponentProps, forwardRef } from 'react';
import { tv } from '../../_lib/utils';
import { Text } from '../../Text';

const styles = tv({
	slots: {
		input:
			'mt-1.5 text-body-md leading-[1.125] text-text-primary placeholder-text-primary/60 transition-all duration-normal ease-smooth w-full p-3 rounded-sm bg-input-background ring-1 ring-input-border focus:ring-input-border-active focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed',
		helperText: 'text-text-secondary',
	},
	variants: {
		hasValue: {
			true: {
				input: 'ring-2 ring-input-border-active',
			},
			false: {
				input: 'hover:ring-input-border-hover',
			},
		},
		hasError: {
			true: {
				input: 'ring-2 ring-input-error hover:ring-input-error focus:ring-input-error',
				helperText: 'text-input-error',
			},
		},
	},
});

type LabelProps = {
	hasError?: boolean;
	hasValue?: boolean;
	label?: string;
	helper?: string;
	disabled?: boolean;
};

export type TextareaProps = Omit<ComponentProps<'textarea'>, 'name' | 'id' | 'ref'> & {
	id: string;
	name: string;
} & LabelProps;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
	{ className, hasError, hasValue, label, helper, disabled, ...props },
	ref,
) {
	const { input, helperText } = styles({ hasError, hasValue });

	return (
		<label className={`relative w-full grid gap-1 ${className || ''}`}>
			<Text as='span' styleType='body-sm-medium'>
				{label}
			</Text>

			{helper && (
				<Text as='span' className={helperText()} styleType='body-xs'>
					{helper}
				</Text>
			)}

			<textarea ref={ref} className={input()} rows={3} {...props} disabled={disabled} />
		</label>
	);
});
